import React from 'react';
import { Result, type ResultProps } from './Result';

export interface ErrorProps extends Omit<ResultProps, 'status'> {}

export const ErrorResult = (props: ErrorProps) => {
  return <Result p={16} {...props} status='error' />;
};
